<mat-dialog-actions class="desktop" [ngClass]="{'space-between': spaceBetween}">
  <ng-container [ngTemplateOutlet]="dialogActions || defaultAction"></ng-container>
</mat-dialog-actions>
<footer class="mobile">
  <mat-dialog-actions [ngClass]="{'space-between': spaceBetween}">
    <ng-container [ngTemplateOutlet]="dialogActions || defaultAction"></ng-container>
  </mat-dialog-actions>
</footer>
<ng-template #defaultAction>
  <button mat-button mat-dialog-close>{{ (defaultActionName || 'general.api_general_close') | translate }}</button>
</ng-template>
